import type { Release } from '../releases';

export default {
  id: '2026-11-02-estimates-project-money',
  at: '2026-11-02T07:33:00Z',
  title: 'Сметы и финплан: доступ к суммам по проекту',
  modules: ['estimates', 'budget'],
  items: [
    'Если доступ к суммам выдан на проект, а не на всю компанию, суммы смет этого проекта, их выгрузки, сравнение версий и финансовый план проекта теперь открыты. В других проектах суммы по-прежнему скрыты.',
  ],
  why: 'Сотрудник с доступом к деньгам только своего проекта не видел сумм в его сметах и финплане.',
  link: '/estimates',
} satisfies Release;
